import React, { useContext, useRef } from 'react';

import { SegmentedControl } from '@imgly/imgly-website-components';
import { uniqueId } from 'lodash';

import { CodeLanguageContext } from '../../../../context/CodeLanguageContext';
import { CodeBlockHeader } from '../../CodeBlockHeader';
import { CodeBlockHeaderTab } from '../../CodeBlockHeaderTabs/CodeBlockHeaderTab';

export const MultiHeader: React.FC = () => {
  const uuid = useRef(uniqueId('code-block-header'));

  const { language, labels, titles, setLanguage } =
    useContext(CodeLanguageContext);

  const options = labels.map((label, index) => ({
    value: index,
    label,
  }));

  const handleChange = (value: string | number | null) => {
    if (typeof value === 'number') {
      setLanguage(value);
    }
  };

  return (
    <CodeBlockHeader>
      {titles[language] && <CodeBlockHeaderTab file={titles[language]} />}
      <SegmentedControl
        name={uuid.current}
        label="Select code block language"
        hideLabel
        disabled={options.length <= 1}
        value={language}
        options={options}
        onChange={handleChange}
      />
    </CodeBlockHeader>
  );
};
